/* NJS 2026 · theme scripts */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmt = (cents) => {
    const f = (window.NJS && NJS.moneyFormat) || '€{{amount_with_comma_separator}}';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_with_comma_separator') return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
      if (k === 'amount_no_decimals') return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_no_decimals_with_comma_separator') return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
    });
  };

  /* header: mega menu */
  $$('[data-mega]').forEach((item) => {
    let t;
    const open = () => { clearTimeout(t); item.classList.add('is-open'); item.querySelector('a').setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); item.querySelector('a').setAttribute('aria-expanded', 'false'); }, 120); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', close);
  });

  /* drawer */
  const drawer = $('#NavDrawer');
  $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', () => { drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); }));
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => { drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); }));

  /* back to top */
  const top = $('[data-totop]');
  if (top) {
    const on = () => top.classList.toggle('is-on', window.scrollY > 900);
    window.addEventListener('scroll', on, { passive: true }); on();
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* tabs */
  $$('[role="tablist"]').forEach((list) => {
    const tabs = $$('[role="tab"]', list);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (tab.dataset.fxTab !== undefined) fxSelect(list.parentElement, tab.dataset.fxTab);
    };
    tabs.forEach((t) => t.addEventListener('click', () => select(t)));
  });
  document.addEventListener('shopify:block:select', (e) => document.getElementById('T-' + e.detail.blockId)?.click());

  /* flavour explorer */
  function fxSelect(root, i) {
    $$('[data-fx-acc]', root).forEach((a) => {
      const on = a.dataset.fxAcc === String(i);
      a.classList.toggle('is-open', on);
      a.querySelector('.fx__acc-head').setAttribute('aria-expanded', on);
    });
    $$('[data-fx-panel]', root).forEach((p) => (p.hidden = p.dataset.fxPanel !== String(i)));
    $$('[data-fx-tab]', root).forEach((t) => t.setAttribute('aria-selected', t.dataset.fxTab === String(i)));
  }
  $$('[data-fx]').forEach((fx) => {
    const root = fx.parentElement;
    $$('[data-fx-acc]', fx).forEach((a) => a.querySelector('.fx__acc-head').addEventListener('click', () => fxSelect(root, a.dataset.fxAcc)));
  });

  /* sliders */
  $$('[data-slider]').forEach((s) => {
    const track = $('.slider__track', s);
    const prev = $('[data-prev]', s), next = $('[data-next]', s);
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300);
    const upd = () => {
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd); upd();
  });

  /* ugc videos */
  $$('[data-play]').forEach((b) => b.addEventListener('click', () => {
    const card = b.closest('.ugc__card'); const v = $('video', card);
    if (!v) return;
    if (v.paused) { v.muted = false; v.play(); card.classList.add('is-playing'); } else { v.pause(); card.classList.remove('is-playing'); }
  }));

  /* team cards */
  $$('[data-team]').forEach((c) => $('.team__toggle', c).addEventListener('click', (e) => {
    const on = c.classList.toggle('is-open'); e.currentTarget.setAttribute('aria-expanded', on);
  }));

  /* reveal (scroll check, works everywhere) */
  const rv = $$('.rv');
  const reveal = () => rv.forEach((el) => { if (!el.classList.contains('in') && el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('in'); });
  window.addEventListener('scroll', reveal, { passive: true });
  window.addEventListener('resize', reveal);
  reveal();
  setTimeout(() => rv.forEach((el) => el.classList.add('in')), 4000);

  /* qty */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    const i = b.parentElement.querySelector('input');
    i.value = Math.max(parseInt(i.min || '0', 10), (parseInt(i.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('form[data-cart-form]').forEach((f) => { let t; f.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => f.submit(), 450); }); });

  /* product page */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const data = JSON.parse($('[data-pdp-json]', pdp).textContent);
    const vInput = $('[data-variant-input]', pdp);
    const pInput = $('[data-plan-input]', pdp);
    const atc = $('[data-atc]', pdp), atcLabel = $('[data-atc-label]', pdp), atcPrice = $('[data-atc-price]', pdp);
    const planSel = $('[data-plan-select]', pdp);
    const subSave = $('[data-sub-save]', pdp);
    const packQty = $('[data-pack-qty]', pdp);
    const segs = $$('[data-option-seg]', pdp);
    const addLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

    let afterUpdate = null;
    let extraTitles = [];
    /* keep in line with the automatic discount "Mix & match 36 cans" in Shopify: packs of 12 above 3 get this discount */
    const MIX_D3 = 0.110184;
    const current = () => {
      const sel = segs.map((s) => $('.seg__opt.is-active', s)?.dataset.value);
      return data.variants.find((v) => v.options.every((o, i) => sel[i] === undefined || o === sel[i])) || data.variants[0];
    };
    const plan = () => (pInput ? pInput.value : '');
    const showSlide = (id) => {
      $$('[data-slide]', pdp).forEach((s) => s.classList.toggle('is-active', s.dataset.slide === String(id)));
      $$('[data-thumb]', pdp).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    const update = (fromUser) => {
      const v = current();
      vInput.value = v.id;
      const p = plan();
      const ex = extraTitles.map((t) => data.variants.find((x) => x.title === t)).filter(Boolean);
      const exF = ex.length ? 1 - MIX_D3 : 1;
      const exOnce = Math.round(ex.reduce((a, x) => a + x.price, 0) * exF);
      const exPlan = (sp) => Math.round(ex.reduce((a, x) => a + (sp && x.plans[sp] !== undefined ? x.plans[sp] : x.price), 0) * exF);
      const exQty = ex.reduce((a, x) => a + (parseInt(x.title, 10) || 0), 0);
      const price = (p && v.plans[p] !== undefined ? v.plans[p] : v.price) + (p ? exPlan(p) : exOnce);
      if (atcPrice) atcPrice.textContent = fmt(price);
      if (atc) { atc.disabled = !v.available; atcLabel.textContent = v.available ? addLabel : 'Sold out'; }
      {
        const sp = (planSel && planSel.value) || $('[data-plan-seg] [data-plan]:not([data-plan=""])', pdp)?.dataset.plan;
        const subP = (sp && v.plans[sp] !== undefined ? v.plans[sp] : v.price) + exPlan(sp);
        const seg = $('[data-plan-seg]', pdp);
        const qn = parseInt(v.title, 10);
        const shipMin = seg ? parseInt(seg.dataset.shipMin || '0', 10) || 0 : 0;
        const shipOn = !qn || !shipMin || qn >= shipMin;
        const shipC = seg && shipOn ? parseInt(seg.dataset.shipCents || '0', 10) || 0 : 0;
        const cmpP = v.price + exOnce + (seg ? parseInt(seg.dataset.giftCents || '0', 10) || 0 : 0) + shipC;
        const s = cmpP - subP;
        if (subSave) { subSave.hidden = s <= 0; if (s > 0) subSave.textContent = (subSave.dataset.tpl || 'Save [pct]').replace('[pct]', Math.round(s * 100 / cmpP) + '%').replace('[amount]', fmt(s).replace(/[.,]00(?!\d)/, '')); }
        $$('[data-ship-perk]', pdp).forEach((el) => { el.hidden = !shipOn; });
        if (qn && data.baseQty) {
          const ref = Math.round(data.basePrice * (qn + exQty) / data.baseQty) + shipC;
          const pct = ref > subP ? Math.round((ref - subP) * 100 / ref) : 0;
          $$('[data-perk-save]', pdp).forEach((el) => { el.textContent = (el.dataset.tpl || '').replace('[pct]', pct + '%'); el.closest('li').hidden = pct <= 0; });
        }
        if (qn) $$('[data-perk-can]', pdp).forEach((el) => { el.textContent = (el.dataset.tpl || '').replace('[price]', fmt(Math.round(subP / (qn + exQty)))); });
        const sv = seg ? parseInt(seg.dataset.servings || '0', 10) || 0 : 0;
        if (sv) $$('[data-perk-serving]', pdp).forEach((el) => { el.textContent = (el.dataset.tpl || '').replace('[price]', fmt(Math.floor(subP / sv))); });
        $$('[data-when-small]', pdp).forEach((el) => { const m = parseInt(el.dataset.smallMax, 10) || 0; el.textContent = qn && qn <= m ? el.dataset.whenSmall : el.dataset.when; });
        $$('[data-ship-nudge]', pdp).forEach((el) => { el.hidden = shipOn; });
        const sP = $('[data-sub-price]', pdp), sC = $('[data-sub-compare]', pdp), oP = $('[data-once-price]', pdp);
        if (sP) sP.textContent = fmt(subP);
        if (sC) { sC.textContent = fmt(cmpP); sC.hidden = s <= 0; }
        if (oP) oP.textContent = fmt(v.price + exOnce);
      }
      const q = (parseInt(v.title, 10) || 0) + exQty;
      if (packQty && q) packQty.textContent = packQty.textContent.replace(/^\d+/, q);
      const packPer = $('[data-pack-per]', pdp);
      if (packPer && q) packPer.textContent = fmt(Math.round(price / q));
      $$('[data-flavour-link]', pdp).forEach((a) => { const u = new URL(a.href, location.origin); u.searchParams.set('size', v.title); a.href = u.pathname + u.search; });
      if (fromUser) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('size'); history.replaceState({}, '', u);
        if (v.media) showSlide(v.media);
      }
      pdp.classList.toggle('is-sub', !!plan());
      if (afterUpdate) afterUpdate(v, fromUser);
    };
    segs.forEach((s) => s.addEventListener('click', (e) => {
      const b = e.target.closest('.seg__opt'); if (!b) return;
      $$('.seg__opt', s).forEach((x) => x.classList.toggle('is-active', x === b)); update(true);
    }));
    const planOpts = $$('[data-plan-seg] [data-plan]', pdp);
    const pickPlan = (b) => {
      planOpts.forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      pInput.value = b.dataset.plan ? (planSel ? planSel.value : b.dataset.plan) : '';
      const f = $('[data-plan-freq]', pdp); if (f && !f.closest('.buy__opt')) f.hidden = !b.dataset.plan;
      update(false);
    };
    planOpts.forEach((b) => {
      b.addEventListener('click', (e) => { if (e.target.closest('select') && b.classList.contains('is-active')) return; pickPlan(b); });
      b.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('select')) { e.preventDefault(); pickPlan(b); } });
    });
    pdp.addEventListener('click', (e) => {
      const sw = e.target.closest('[data-ship-switch]'); if (!sw || !segs[0]) return;
      e.preventDefault(); e.stopPropagation();
      const b = $$('.seg__opt', segs[0]).find((x) => x.dataset.value === sw.dataset.shipSwitch);
      if (b) b.click();
    });
    planSel?.addEventListener('change', () => { const sub = planOpts.find((x) => x.dataset.plan); if (!pInput.value && sub) { pickPlan(sub); return; } if (pInput.value) pInput.value = planSel.value; update(false); });

    /* flavour mixer: packs of 12 spread over the flavours. The flavour + and - set the pack size;
       above the biggest pack the extra packs are added as extra cart lines (no extra perks). */
    const mix = $('[data-mix]', pdp);
    if (mix) {
      const mdata = JSON.parse($('[data-mix-json]', mix).textContent);
      const cards = $$('[data-mix-flavour]', mix);
      const ids = cards.map((c) => c.dataset.mixFlavour);
      const step = parseInt(mix.dataset.step, 10) || 12;
      const countEl = $('[data-mix-count]', mix), props = $('[data-mix-props]', mix);
      const curId = ids.find((k) => mdata[k] && mdata[k].current) || ids[0];
      const seg0 = segs[0];
      const segBtns = seg0 ? $$('.seg__opt', seg0) : [];
      const sizes = segBtns.map((b) => parseInt(b.dataset.value, 10)).filter((n) => n > 0).sort((a, b) => a - b);
      const maxPk = sizes.length ? Math.max(1, Math.round(sizes[sizes.length - 1] / step)) : 3;
      const unit = packQty ? packQty.textContent.replace(/^\s*\d+\s*/, '').trim() : '';
      const nameOf = (k) => (cards.find((c) => c.dataset.mixFlavour === k) || {}).dataset?.name || '';
      const qty = {}; let segPk = null;
      const sum = () => ids.reduce((a, k) => a + (qty[k] || 0), 0);
      const byQty = () => ids.slice().sort((a, b) => (qty[b] || 0) - (qty[a] || 0) || (a === curId ? -1 : b === curId ? 1 : 0));
      const setSeg = (pk) => {
        const val = String(Math.min(pk, maxPk) * step);
        const b = segBtns.find((x) => x.dataset.value === val);
        if (b) segBtns.forEach((x) => x.classList.toggle('is-active', x === b));
        segPk = Math.min(pk, maxPk);
      };
      const fit = (pk) => {
        let n = sum();
        if (n < pk) { const k = byQty()[0] || curId; qty[k] = (qty[k] || 0) + (pk - n); }
        while (n > pk) { const k = byQty().reverse().find((x) => qty[x] > 0); qty[k]--; n--; }
      };
      const render = () => {
        const n = sum();
        cards.forEach((c) => {
          const q = qty[c.dataset.mixFlavour] || 0;
          $('[data-mix-qty]', c).textContent = q;
          c.classList.toggle('is-active', q > 0);
          $('[data-mix-dec]', c).disabled = q <= 0 || n <= 1;
          $('[data-mix-inc]', c).disabled = false;
        });
        if (countEl) { countEl.textContent = n > maxPk ? (n * step) + ' ' + unit : ''; countEl.hidden = n <= maxPk; countEl.classList.add('is-done'); }
        props.innerHTML = '';
        /* above the biggest pack the extra packs of 12 are priced like the biggest pack */
        const nt = n > maxPk ? Array(n - maxPk).fill(String(step)) : [];
        const changed = nt.join() !== extraTitles.join();
        extraTitles = nt;
        return changed;
      };
      afterUpdate = (v, fromUser) => {
        const pk = Math.round((parseInt(v.title, 10) || 0) / step);
        if (segPk === null) { ids.forEach((k) => (qty[k] = 0)); qty[curId] = pk; segPk = pk; }
        else if (pk !== segPk || (fromUser && sum() !== pk)) { fit(pk); segPk = pk; }
        if (render()) update(false);
      };
      mix.addEventListener('click', (e) => {
        const b = e.target.closest('[data-mix-inc],[data-mix-dec]'); if (!b) return;
        const id = b.closest('[data-mix-flavour]').dataset.mixFlavour;
        const inc = b.hasAttribute('data-mix-inc');
        if (!inc && ((qty[id] || 0) <= 0 || sum() <= 1)) return;
        qty[id] = (qty[id] || 0) + (inc ? 1 : -1);
        setSeg(sum()); render(); update(false);
      });
      const form = pdp.querySelector('form');
      form.addEventListener('submit', (e) => {
        const v = current(), p = pInput ? pInput.value : '';
        const cur = mdata[curId].variants[v.title];
        const ix = cur && p ? cur.plans.indexOf(p) : -1;
        const flv = byQty().filter((k) => (qty[k] || 0) > 0);
        const n = sum();
        if (flv.length <= 1 && n <= maxPk) {
          /* one flavour in one pack: a single line on that flavour */
          const tv = flv[0] && mdata[flv[0]].variants[String(n * step)];
          if (!tv || tv.id === parseInt(vInput.value, 10)) return;
          const oldV = vInput.value, oldP = pInput ? pInput.value : '';
          vInput.value = tv.id;
          if (pInput && pInput.value) pInput.value = tv.plans[ix] || tv.plans[0] || '';
          setTimeout(() => { vInput.value = oldV; if (pInput) pInput.value = oldP; }, 0);
          return;
        }
        /* mixed flavours, or more than the biggest pack: one line per flavour in packs of 12,
           so the order (and the warehouse) gets the right cans. The automatic Mix & match
           discounts bring the price back to the pack price. */
        e.preventDefault(); e.stopImmediatePropagation();
        const items = flv.map((k) => {
          const tv = mdata[k].variants[String(step)];
          const it = { id: tv.id, quantity: qty[k] };
          if (p) it.selling_plan = tv.plans[ix] || tv.plans[0];
          return it;
        });
        const err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
        atc?.setAttribute('aria-busy', 'true');
        fetch(NJS.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
          .then((r) => r.json().then((d) => { if (!r.ok) throw new Error(d.description || d.message || 'Error'); return d; }))
          .then(async (d) => {
            if (!(window.NJS && NJS.ajaxCart)) { location.href = NJS.routes.cart_url; return; }
            const cart = await (await fetch(NJS.routes.cart_url + '.js')).json();
            $$('[data-cart-count]').forEach((c) => (c.textContent = cart.item_count));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('product:added', { detail: { item: d, cart } }));
          })
          .catch((x) => { if (err) { err.textContent = x.message; err.hidden = false; } })
          .finally(() => atc?.removeAttribute('aria-busy'));
      }, true);
    }

    /* keep pack size when switching flavour */
    const size = new URLSearchParams(location.search).get('size');
    if (size && segs[0]) { const b = $$('.seg__opt', segs[0]).find((x) => x.dataset.value === size); if (b) { $$('.seg__opt', segs[0]).forEach((x) => x.classList.toggle('is-active', x === b)); } }
    update(false);

    $$('[data-thumb]', pdp).forEach((t) => t.addEventListener('click', () => showSlide(t.dataset.thumb)));
    const lb = $('[data-lightbox]');
    $('[data-zoom]', pdp)?.addEventListener('click', () => {
      const img = $('.pdp__slide.is-active img', pdp); if (!img || !lb) return;
      $('[data-lb-img]', lb).src = img.currentSrc || img.src; lb.classList.add('is-open'); document.body.classList.add('no-scroll');
    });
    lb?.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('[data-lb-close]')) { lb.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } });
  }

  /* ajax add to cart (cart apps like Upcart open their drawer on this) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !(window.NJS && NJS.ajaxCart)) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]'); btn?.setAttribute('aria-busy', 'true');
    const err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
    try {
      const fd = new FormData(form);
      if (!fd.get('selling_plan')) fd.delete('selling_plan');
      const res = await fetch(NJS.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const d = await res.json();
      if (!res.ok) throw new Error(d.description || d.message || 'Error');
      const cart = await (await fetch(NJS.routes.cart_url + '.js')).json();
      $$('[data-cart-count]').forEach((c) => (c.textContent = cart.item_count));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('product:added', { detail: { item: d, cart } }));
    } catch (x) {
      if (err) { err.textContent = x.message; err.hidden = false; } else { form.removeAttribute('data-ajax-cart'); form.submit(); }
    } finally { btn?.removeAttribute('aria-busy'); }
  });
})();
